import type { ViteEnvironmentClient } from "@core/data/infrastructures/vite-environment-client.ts";
import { container } from "@di/inversify.config";
import { coreTypes } from "@iot-platform/core";

export const useEnvironment = (): ViteEnvironmentClient =>
    container.get<ViteEnvironmentClient>(
        coreTypes.infrastructure.EnvironmentClient,
    );
